
import moment from "moment";


const dateHolders = {
    startDate : moment().subtract("7", "Days").format('YYYY-MM-DD'),
    endDate : moment().format('YYYY-MM-DD'),
    // dateMessage : "Please Select Date Range Less Than A Month",
    approvalData:[],
    individualData: [],
}


const approvalReducer = (state=dateHolders, action)=>{
    if(action.type === "SET_DATE"){
        return state = {...state,...action.payload};
    }else if(action.type === "SET_APPROVAL_DATA"){
        return state = {...state,...action.payload};
    // }else if(action.type === "SET_REJECTED_RESPONSE"){
    //     return state = {...state,...action.payload};
    }
    else if(action.type === "SET_APPROVED_RESPONSE"){
        return state = {...state,...action.payload};
    }
    return state;
};

export default approvalReducer;